/*
 * Modern remove animation for cart drawer line items.
 *
 * Dawn's default behaviour shows a loading spinner over the item and then
 * swaps the drawer HTML, so items just blink out. Instead we collapse the
 * card (height -> 0) while fading and sliding it out. The cart still updates
 * via Dawn's own logic; this only animates the outgoing card during the
 * network round-trip, after which the drawer re-renders without the item.
 */
(function () {
  'use strict';

  function onClick(event) {
    var button = event.target.closest('.cart-item__remove');
    if (!button) return;

    var item = button.closest('.cart-item');
    if (!item || item.classList.contains('cart-item--removing')) return;

    // Lock the current height so it can transition down to 0.
    item.style.maxHeight = item.offsetHeight + 'px';
    // Force a reflow so the starting height is committed before the transition.
    void item.offsetHeight;
    item.classList.add('cart-item--removing');
  }

  function init() {
    // #CartDrawer persists across re-renders; its innerHTML is swapped, so a
    // delegated listener here survives every cart update.
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
